import React, { useEffect, useState } from 'react';
import { API_ENDPOINTS } from '../config/api';
import { apiFetch } from '../utils/apiClient';
import './Footer.css';

const DEFAULT_SITE = {
  company: '湖南迪亚环境工程股份有限公司',
  icp: '湘ICP备2023020953号-2',
  address: '湖南省长沙市雨花区振华路579号康庭园一期20栋',
  phone: '0731-85829688',
};

const Footer = () => {
  const [siteInfo, setSiteInfo] = useState(DEFAULT_SITE);

  useEffect(() => {
    apiFetch(API_ENDPOINTS.SITE_INFO)
      .then((json) => {
        if (json && json.success && json.data) {
          setSiteInfo((prev) => ({
            company: json.data.company || prev.company,
            icp: json.data.icp || prev.icp,
            address: json.data.address || prev.address,
            phone: json.data.phone || prev.phone,
          }));
        }
      })
      .catch(() => {});
  }, []);

  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <div className="footer-company">
          {siteInfo.company}
          <span className="footer-stock">股票代码 874057</span>
        </div>
        <div className="footer-meta">
          {siteInfo.phone && (
            <span>
              电话：
              <a href={`tel:${siteInfo.phone.replace(/-/g, '')}`}>{siteInfo.phone}</a>
            </span>
          )}
          {siteInfo.address && <span>地址：{siteInfo.address}</span>}
          {siteInfo.icp && (
            <span>
              备案号：
              <a
                href="https://beian.miit.gov.cn/"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-icp-link"
              >
                {siteInfo.icp}
              </a>
            </span>
          )}
        </div>
        <div className="footer-divider" />
        <p className="footer-copyright">版权所有 © {siteInfo.company}</p>
        <div className="footer-official">
          <a href="https://www.hndyhj.com/" target="_blank" rel="noopener noreferrer">
            访问企业官网 www.hndyhj.com
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
